import { ChangeDetectionStrategy, Component, DestroyRef, Inject, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ProductDataFilenameConventionService } from 'src/app/services/product-data-filename-conventions/product-data-filename-convention.service';
import {
  DEFAULT_FILENAME,
  ProductDataFilenameConvention,
  ProductDataFilenameConventionFilename,
} from 'src/app/models/product-data-filename-conventions/product-data-filename-convention';

export interface CreateProductDataFilenameConventionDialogData {
  organizationId: string;
}

// First-save dialog — no Reason UI. Server writes WriteReason=InitialSetup.
@Component({
  selector: 'app-create-product-data-filename-convention-dialog',
  templateUrl: './create-product-data-filename-convention-dialog.component.html',
  styleUrls: ['./create-product-data-filename-convention-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class CreateProductDataFilenameConventionDialogComponent {
  private readonly destroyRef = inject(DestroyRef);

  readonly seedValue: ProductDataFilenameConventionFilename = { ...DEFAULT_FILENAME };
  currentValue: ProductDataFilenameConventionFilename | null = null;
  formIsValid = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CreateProductDataFilenameConventionDialogData,
    private readonly dialogRef: MatDialogRef<
      CreateProductDataFilenameConventionDialogComponent,
      ProductDataFilenameConvention | undefined
    >,
    private readonly service: ProductDataFilenameConventionService,
  ) {}

  get canCreate(): boolean {
    return this.formIsValid && this.currentValue !== null;
  }

  onFormValue(value: ProductDataFilenameConventionFilename): void {
    this.currentValue = value;
  }

  onFormValid(valid: boolean): void {
    this.formIsValid = valid;
  }

  create(): void {
    if (!this.canCreate || this.currentValue === null) return;
    this.service
      .create(this.data.organizationId, {
        filename: this.currentValue,
        writeReason: { kind: 'initialSetup' },
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result: ProductDataFilenameConvention) => this.dialogRef.close(result));
  }

  cancel(): void {
    this.dialogRef.close(undefined);
  }
}
